"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _ClickAwayListener = _interopRequireDefault(require("../ClickAwayListener"));

var _Box = _interopRequireDefault(require("../Box"));

var _InputAdornment = _interopRequireDefault(require("../InputAdornment"));

var _TextField = _interopRequireDefault(require("../TextField"));

var _DatePicker = require("../DatePicker");

var _icons = require("../../icons");

var _styles = require("@material-ui/styles");

var _excluded = ["startDate", "endDate", "dateFormat", "onChange", "valueFormatter", "type"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    align: {
      '& .dialog-date-picker.open': {
        left: '1.25rem'
      }
    },
    textField: {
      '& .MuiInputBase-input': {
        cursor: 'pointer',
        textAlign: 'center'
      },
      '& .MuiInputBase-root ': {
        cursor: 'pointer'
      }
    }
  };
});

var CustomDateRangePicker = function CustomDateRangePicker(_ref) {
  var _props$id, _props$InputProps;

  var startDate = _ref.startDate,
      endDate = _ref.endDate,
      dateFormat = _ref.dateFormat,
      onChange = _ref.onChange,
      valueFormatter = _ref.valueFormatter,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpenCalendar = _useState2[0],
      setIsOpenCalendar = _useState2[1];

  var handleOpenDialog = function handleOpenDialog() {
    return setIsOpenCalendar(true);
  };

  var handleCloseDialog = function handleCloseDialog() {
    return setIsOpenCalendar(false);
  };

  var handleDate = function handleDate(date) {
    return new Date(date);
  };

  var handleDateText = function handleDateText() {
    return valueFormatter(startDate, endDate);
  };

  return /*#__PURE__*/_react.default.createElement(_ClickAwayListener.default, {
    onClickAway: function onClickAway() {
      return handleCloseDialog();
    }
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.align
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({
    onClick: handleOpenDialog,
    className: classes.textField,
    variant: "outlined",
    id: (_props$id = props === null || props === void 0 ? void 0 : props.id) !== null && _props$id !== void 0 ? _props$id : 'custom-date-range-picker',
    InputProps: (_props$InputProps = props === null || props === void 0 ? void 0 : props.InputProps) !== null && _props$InputProps !== void 0 ? _props$InputProps : {
      readOnly: true,
      startAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
        position: "start"
      }, /*#__PURE__*/_react.default.createElement(_icons.DateRangeOutlined, {
        fontSize: "small"
      })),
      endAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
        position: "start"
      }, /*#__PURE__*/_react.default.createElement(_icons.ExpandMore, {
        fontSize: "small"
      }))
    },
    value: handleDateText()
  }, props)), type === 'single' ? /*#__PURE__*/_react.default.createElement(_DatePicker.SingleDatePicker, _extends({
    dateFormat: dateFormat,
    isOpen: isOpenCalendar,
    onCloseCalendar: handleCloseDialog,
    ignoreDefaultControls: true,
    startDate: handleDate(startDate),
    onChange: onChange,
    singleCalendar: true
  }, props)) : /*#__PURE__*/_react.default.createElement(_DatePicker.RangeDatePicker, _extends({
    dateFormat: dateFormat,
    isOpen: isOpenCalendar,
    ignoreDefaultControls: true,
    onChange: onChange,
    onCloseCalendar: handleCloseDialog,
    startDate: handleDate(startDate),
    endDate: handleDate(endDate)
  }, props))));
};

CustomDateRangePicker.defaultProps = {
  startDate: (0, _moment.default)().subtract('1', 'month').format('YYYY-MM-DD'),
  endDate: (0, _moment.default)().format('YYYY-MM-DD'),
  dateFormat: 'YYYY-MM-DD',
  onChange: function onChange() {},
  valueFormatter: function valueFormatter(startDate, endDate) {
    return "".concat(startDate, " - ").concat(endDate);
  },
  type: 'range'
};
CustomDateRangePicker.propTypes = {
  startDate: _propTypes.default.string,
  endDate: _propTypes.default.string,
  dateFormat: _propTypes.default.string,
  onChange: _propTypes.default.func,
  valueFormatter: _propTypes.default.func,
  type: _propTypes.default.string
};
var _default = CustomDateRangePicker;
exports.default = _default;